import React from 'react';
import { motion } from 'framer-motion';
interface AnalogClockProps {
  hours: number;
  minutes: number;
  seconds?: number;
  size?: number;
  showSeconds?: boolean;
  className?: string;
}
export function AnalogClock({
  hours,
  minutes,
  seconds = 0,
  size = 200,
  showSeconds = true,
  className = ''
}: AnalogClockProps) {
  // Calculate angles
  // Hours: (hours % 12) * 30 degrees + (minutes / 60) * 30 degrees
  const hourAngle = hours % 12 * 30 + minutes / 60 * 30;
  // Minutes: minutes * 6 degrees + (seconds / 60) * 6 degrees
  const minuteAngle = minutes * 6 + seconds / 60 * 6;
  // Seconds: seconds * 6 degrees
  const secondAngle = seconds * 6;
  return <div className={`relative rounded-full bg-white shadow-lg border-4 border-slate-200 ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-1687">

      {/* Clock Face Numbers */}
      {[...Array(12)].map((_, i) => {
      const num = i + 1;
      const rotation = num * 30;
      // Position numbers in a circle
      // Radius is slightly less than half size to fit inside
      const radius = size / 2 - 25;
      const angleInRadians = (rotation - 90) * (Math.PI / 180);
      const x = size / 2 + radius * Math.cos(angleInRadians);
      const y = size / 2 + radius * Math.sin(angleInRadians);
      return <div key={num} className="absolute flex items-center justify-center font-bold text-slate-700" style={{
        width: 24,
        height: 24,
        left: x - 12,
        top: y - 12,
        fontSize: size > 150 ? '1.1rem' : '0.8rem'
      }} data-id="element-1688">

            {num}
          </div>;
    })}

      {/* Minute Marks */}
      {[...Array(60)].map((_, i) => {
      if (i % 5 === 0) return null; // Skip where numbers are
      const rotation = i * 6;
      return <div key={`mark-${i}`} className="absolute bg-slate-300 origin-bottom" style={{
        width: 2,
        height: 6,
        left: 'calc(50% - 1px)',
        top: 10,
        transformOrigin: `50% ${size / 2 - 10}px`,
        transform: `rotate(${rotation}deg)`
      }} data-id="element-1689" />;
    })}

      {/* Hour Hand */}
      <motion.div className="absolute bg-slate-800 rounded-full origin-bottom z-10" style={{
      width: 6,
      height: size * 0.25,
      left: 'calc(50% - 3px)',
      bottom: '50%',
      borderRadius: '4px 4px 0 0'
    }} animate={{
      rotate: hourAngle
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 15
    }} data-id="element-1690" />


      {/* Minute Hand */}
      <motion.div className="absolute bg-slate-600 rounded-full origin-bottom z-20" style={{
      width: 4,
      height: size * 0.35,
      left: 'calc(50% - 2px)',
      bottom: '50%',
      borderRadius: '4px 4px 0 0'
    }} animate={{
      rotate: minuteAngle
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 15
    }} data-id="element-1691" />


      {/* Second Hand */}
      {showSeconds && <motion.div className="absolute bg-red-500 rounded-full origin-bottom z-30" style={{
      width: 2,
      height: size * 0.4,
      left: 'calc(50% - 1px)',
      bottom: '50%',
      borderRadius: '2px 2px 0 0'
    }} animate={{
      rotate: secondAngle
    }} transition={{
      type: 'spring',
      stiffness: 150,
      damping: 10
    }} data-id="element-1692" />}

      {/* Center Dot */}
      <div className="absolute bg-slate-800 rounded-full z-40" style={{
      width: 12,
      height: 12,
      left: 'calc(50% - 6px)',
      top: 'calc(50% - 6px)',
      border: '2px solid white'
    }} data-id="element-1693" />


      {showSeconds && <div className="absolute bg-red-500 rounded-full z-50" style={{
      width: 6,
      height: 6,
      left: 'calc(50% - 3px)',
      top: 'calc(50% - 3px)'
    }} data-id="element-1694" />}
    </div>;
}